import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Form } from 'semantic-ui-react';
import { get } from 'lodash';
import { states } from '@/constants/lifecycle';
import FormValidationError from '@/components/errors/FormValidationError';
import Dialog from '@/components/dialogs/Dialog';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import { hideApproveRequest, approveRequest, denyRequest } from '../actions';
import { approvalStatus, requestTransferTypes } from '../constants';

const RequestApprovalDialog = ({
  action,
  allowPmnTransfer,
  approve,
  deny,
  hide,
  results,
  theme,
}) => {
  const intl = useIntl();
  const [reason, setReason] = useState('');

  const datasetName = get(results, '[0].datasets[0].catalogue.title', '');

  const confirmText = () => (action === approvalStatus.APPROVE ? 'request.approve.button' : 'request.deny.button');

  const titleText = () => {
    let message = action === approvalStatus.APPROVE ? 'request.approve.title' : 'request.deny.title';
    if (action === approvalStatus.APPROVE && results.length === 1 && allowPmnTransfer) {
      message = {
        [requestTransferTypes.CLEAR]: 'request.approve.clear.title',
        [requestTransferTypes.PMN]: 'request.approve.pseudonymised.title',
        [requestTransferTypes.MANUAL]: 'request.approve.manual.title',
        [requestTransferTypes.TOKEN]: 'request.approve.token.title',
      }[results[0].transfer.transfer_type];
    }

    return intl.formatMessage({ id: message });
  };

  const iconName = () => (action === approvalStatus.APPROVE ? 'thumbs up' : 'thumbs down');

  const saving = () => results.some((result) => result.saveStatus === states.PENDING);

  const handleClose = () => {
    setReason('');
    hide();
  };

  const submitForm = () => {
    if (action === approvalStatus.APPROVE) {
      approve(results, reason);
    }

    if (action === approvalStatus.DENY) {
      deny(results, reason);
    }
    setReason('');
  };

  return (
    <Dialog
      className="aridhia-request-approval-dialog"
      icon={iconName()}
      inProgress={saving()}
      message={action === approvalStatus.APPROVE ? 'request.approve.text' : 'request.deny.text'}
      minimumDataEntryMet={reason}
      onClose={handleClose}
      onSave={submitForm}
      saveMessageId={confirmText()}
      theme={theme}
      title={titleText()}
      values={{ datasetName }}
    >
      <Form autoComplete="off" onSubmit={submitForm} className="aridhia-margin-top-small">
        <FormValidationError
          htmlFor="confirm_name"
          labelId="request.approve.reason"
        >
          <MarkdownEditor
            id="confirm_name"
            disabled={saving()}
            value={reason}
            onChange={(value) => setReason(value)}
            maxEditorHeight={80}
            minPreviewHeight={94}
          />
        </FormValidationError>
      </Form>
    </Dialog>
  );
};

const mapStateToProps = ({
  requests: { requests, allowPmnTransfer },
}) => ({
  results: requests.approval.results,
  action: requests.approval.action,
  allowPmnTransfer,
});

const mapDispatchToProps = {
  approve: approveRequest,
  deny: denyRequest,
  hide: hideApproveRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestApprovalDialog);
